import { createReducer, on } from '@ngrx/store';
import { initialLoadingStore } from './loading.store';
import { HeadProductDetailsActions } from '../head-product-details/head-product-details.actions';
import { ProductCatalogActions } from '../catalog/product-catalog.actions';

export const loadingReducer = createReducer(
  initialLoadingStore,

  on(
    HeadProductDetailsActions.getHeadProduct,
    (state) => ({
      ...state,
      public: {
        ...state.public,
        catalog: { ...state.public.catalog, getHeadProduct: true }
      }
    })
  ),
  on(
    HeadProductDetailsActions.getHeadProductSuccess,
    HeadProductDetailsActions.getHeadProductFailure,
    (state) => ({
      ...state,
      public: {
        ...state.public,
        catalog: { ...state.public.catalog, getHeadProduct: false }
      }
    })
  ),

  on(
    ProductCatalogActions.getProductCatalog,
    (state) => ({
      ...state,
      public: {
        ...state.public,
        catalog: { ...state.public.catalog, getProductCatalogs: true }
      }
    })
  ),
  on(
    ProductCatalogActions.getProductCatalogSuccess,
    ProductCatalogActions.getProductCatalogFailure,
    (state) => ({
      ...state,
      public: {
        ...state.public,
        catalog: { ...state.public.catalog, getProductCatalogs: false }
      }
    })
  ),
);
